module.exports = __webpack_public_path__ + "img/opensea-logo.a4952dcb.svg";